// extracted by css-extract-rspack-plugin
export default {"labelText":"labelText-16qqc","textarea":"textarea-3EQLa","invalid":"invalid-32YO-","resizable":"resizable-3fv6I"};